import { Component, Input, AfterViewInit, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: './description-modal.component.html',
  styleUrls: ['./description-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DescriptionModalComponent implements AfterViewInit {
  @Input()
  public title: string;

  @Input()
  public descriptionHtml: string;

  @Input()
  public description: string;

  constructor(private readonly bsModalRef: BsModalRef, private readonly elementRef: ElementRef) {}

  public ngAfterViewInit(): void {
    // Set all links in readonly content to open in new tab
    setTimeout(() => {
      const links = this.elementRef.nativeElement.querySelectorAll('.froala-readonly-container a');
      links.forEach((link: HTMLAnchorElement) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    });
  }

  public close(): void {
    this.bsModalRef.hide();
  }
}
